import { render, staticRenderFns } from "./AgricultureAreaControl.vue?vue&type=template&id=b5f72e28&scoped=true"
import script from "./AgricultureAreaControl.vue?vue&type=script&lang=js"
export * from "./AgricultureAreaControl.vue?vue&type=script&lang=js"
import style0 from "./AgricultureAreaControl.vue?vue&type=style&index=0&id=b5f72e28&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f72e28",
  null
  
)

export default component.exports